import PropTypes from 'prop-types'

const Delay = async (interval, timeoutValue, valueDelayed, callDelayed) => {
  if (interval) {
    window.clearTimeout(interval)
  }
  let newDelay = window.setTimeout(callDelayed, timeoutValue, valueDelayed)
  return newDelay
}

Delay.propTypes = {
  interval: PropTypes.any,
  timeoutValue: PropTypes.number,
  valueDelayed: PropTypes.any,
  callDelayed: PropTypes.func
}

export default Delay



// WEBPACK FOOTER //
// ./src/features/LikePlus/Interval/Delay.js